<template>
  <div class="PaymentInformation">
    <template v-if="checkoutStep">
      <r-app-text-input
        v-if="isDisplayTax"
        :label="$t('checkout.payment.tax.tips', 'Tax to be collected')"
        :placeholder="$t('checkout.payment.tax.tips', 'Tax to be collected')"
        :value="taxAmount | formatCurrency(true)"
        disabled
        :top-label="topLabel"
      />
      <r-app-text-input
        v-if="cardNumber"
        :label="isCreditCard ? $t('myaccount.paymentDetails.textLable.creditcard', 'Credit card') : $t('myaccount.paymentDetails.textLable.BankNumber', 'Bank Number')"
        :value="cardNumber"
        disabled
        :top-label="topLabel"
      />
      <r-app-text-input
        v-if="cardName"
        :label="isCreditCard ? $t('myaccount.paymentDetails.textLable.cardName', 'Name on card') : $t('myaccount.paymentDetails.textLable.bankHolderName', 'Bank Holder Name')"
        :value="cardName"
        disabled
        :top-label="topLabel"
      />
      <r-app-text-input
        v-if="isCreditCard"
        :label="$t('myaccount.paymentDetails.textLable.cardExpDate', 'Exp. date')"
        :value="normalizedPaymentDetails.expiryDate"
        disabled
        :top-label="topLabel"
      />
      <!-- <r-app-text-input
        v-if="normalizedPaymentDetails.type === 'PayPal'"
        :label="$t('myaccount.paymentDetails.textLable.cardExpDate', 'Exp. date')"
        :value="normalizedPaymentDetails.expiryDate"
        disabled
        :top-label="topLabel"
      /> -->
      <r-app-text-input
        v-if="normalizedPaymentDetails.type === 'PayPal'"
        :label="$t('myaccount.paymentDetails.textLable.payerAccount', 'Account of PayPal')"
        :value="payerAccountInfo"
        disabled
        :top-label="topLabel"
      />
    </template>

    <template v-else>
      <app-text-input
        v-if="normalizedPaymentDetails.type === 'Bank'"
        :label="$t('myaccount.paymentDetails.textLable.idealpayment', 'PaymentMethod')"
        :value="$t('myaccount.paymentDetails.textLable.ideal', 'iDEAL')"
        :disabled="true"
        data-name="myAccountPersonalDetail-payerAccount"
      /> 
      
      <app-text-input
        v-if="cardNumber"
        :label="isCreditCard ? $t('myaccount.paymentDetails.textLable.creditcard', 'Credit card') : $t('myaccount.paymentDetails.textLable.BankNumber', 'Bank Number')"
        v-model.trim="cardNumber"
        :disabled="true"
        data-name="myAccountPersonalDetail-creditcard"
      />
      <app-text-input
        v-if="cardName"
        :label="isCreditCard ? $t('myaccount.paymentDetails.textLable.cardName', 'Name on card') : $t('myaccount.paymentDetails.textLable.bankHolderName', 'Bank Holder Name')"
        v-model.trim="cardName"
        :disabled="true"
        data-name="myAccountPersonalDetail-cardName"
      />
      <app-text-input
        v-if="isCreditCard"
        :label="$t('myaccount.paymentDetails.textLable.cardExpDate', 'Exp. date')"
        v-model.trim="normalizedPaymentDetails.expiryDate"
        :disabled="true"
        data-name="myAccountPersonalDetail-cardExpDate"
      />
      <!-- <app-text-input
        v-if="normalizedPaymentDetails.type === 'PayPal'"
        :label="$t('myaccount.paymentDetails.textLable.cardExpDate', 'Exp. date')"
        v-model.trim="normalizedPaymentDetails.expiryDate"
        :disabled="true"
        data-name="myAccountPersonalDetail-cardExpDate"
      /> -->
      <app-text-input
        v-if="normalizedPaymentDetails.type === 'PayPal'"
        :label="$t('myaccount.paymentDetails.textLable.payerAccount', 'Account of PayPal')"
        v-model.trim="payerAccountInfo"
        :disabled="true"
        data-name="myAccountPersonalDetail-payerAccount"
      />
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'payment-information',

    props: {
      checkoutStep: {
        type: Boolean,
        default: false
      },

      taxAmount: {
        type: Number,
        default: null
      },

      isDisplayTax: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        topLabel: true
      }
    },

    computed: {
      ...mapGetters('account', ['normalizedPaymentDetails']),

      isCreditCard () {
        return this.normalizedPaymentDetails.type === 'CreditCard'
      },

      cardName () {
        if (this.isCreditCard) {
          return this.normalizedPaymentDetails.nameOnCard
        } else if (this.normalizedPaymentDetails.type === 'Bank') {
          return this.normalizedPaymentDetails.bankAccountOwnerName
        } else {
          return null
        }
      },

      cardNumber () {
        if (this.isCreditCard) {
          return this.normalizedPaymentDetails.cardNumber
        } else if (this.normalizedPaymentDetails.type === 'Bank') {
          return this.normalizedPaymentDetails.bankAccountNumber
        } else {
          return null
        }
      },

      payerAccountInfo () {
        if (this.normalizedPaymentDetails.type === 'PayPal') {
          // paypal payerAccount is null, need display text
          // return this.normalizedPaymentDetails.paymentMethodName + ' ' + this.normalizedPaymentDetails.payerAccount
          return this.normalizedPaymentDetails.paymentMethodName
        } else {
          return null
        }
      }
    }
  }
</script>
